import { useState, useEffect } from "react";
import Order from "../../../actions/order";
import Notify from "../../../components/customHelpers/Notify";

export const useOrderManagement = () => {
  const { NotifyMessage } = Notify();
  const { viewOrderProducts } = Order();
  const [orders, setOrders] = useState([]);

  const getAllOrders = () => {
    viewOrderProducts().then((data) => {
      if (data.err) {
        NotifyMessage({
          message: data.err,
          type: "error",
        });
      } else if (data.orders) {
      
        setOrders(data.orders);
      }
    });
  };
console.log(orders)
  const filterOrdersByProductId = (productId) => {
    return orders
      .filter((order) =>
        order.orderProducts.some((product) => product.sku === productId)
      )
      .map((order) => {
        const totalQuantity = order.orderProducts
          .filter((product) => product.sku === productId)
          .reduce(
            (total, product) => total + parseInt(product.quantity, 10),
            0
          );

        return {
          status: order.status,
          totalQuantity: totalQuantity,
        };
      });
  };
  const groupByStatusAndSumQuantities = (filteredResults) => {
    const groupedResults = {};

    const possibleStatuses = ["Ordered", "Pending"];
    possibleStatuses.forEach((status) => {
      groupedResults[status] = 0;
    });

    filteredResults.forEach((result) => {
      if (groupedResults[result.status] !== undefined) {
        groupedResults[result.status] += result.totalQuantity;
      }
    });

    return Object.keys(groupedResults).map((status) => ({
      status: status,
      totalQuantity: groupedResults[status],
    }));
  };

  useEffect(() => {
    getAllOrders();
  }, []);

  return {
    orders,
    filterOrdersByProductId,
    groupByStatusAndSumQuantities,
  };
};
